  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   

    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "AulaPdf",
        components: {  CardRh  },   
    }) 
    export default class AulaPdf extends Vue { 
        
        @authStore.Getter
		public token!: any 

        @Prop( ) readonly aula!: any  
        @Prop( ) readonly service!: any  
         
        @Prop( ) readonly modal!: any

        public identificador = 1 ;   
        public url: any = "";
         
        public height_w: any =  window.innerHeight;
        public height_s: any =  screen.height;

        @Watch('aula')
		dadosAtualizado(newVal: string) { 
            this.gerarBoletim(); 
		} 
  
        public gerarBoletim(){
            this.url =   null; 
            if(this.aula){
                setTimeout(() => {
                    // this.url = this.service.getApiUrl() + '/' + "1000" + '/pdf' + '?token=' + this.token ;
                    this.url = this.service.getApiUrl() + '/' + this.aula + '/Pdf' + '?token=' + this.token ;
                    this.identificador++;
                }, 2 ); 
            } 
            
        }
    } 
